<template>
    <div class="dashboard super-admin-shell">
        <Sidebar />
        <div class="page">
            <div class="content dashboard">
                <slot />
            </div>
            <footer class="super-admin-footer">
                <p>Copyright © 2025 | Todos os direitos reservados</p>
                <AppVersionLabel product="weeduc" />
            </footer>
        </div>
    </div>
</template>

<script>
    import Sidebar from '@/components/Weflix/Sidebar-SuperAdmin.vue';
    import AppVersionLabel from '@/components/AppVersionLabel.vue';
    import { applySuperAdminBranding } from '@/utils/superAdmin/branding';

    export default {
        name: 'SuperAdminShell',
        components: {
            Sidebar,
            AppVersionLabel,
        },
        mounted() {
            applySuperAdminBranding();
        },
        activated() {
            applySuperAdminBranding();
        },
    };
</script>

<style>
    @import url('@/css/weflix/super-admin-shell.css');
</style>
